import { FragmentOf, readFragment } from "gql.tada";
import { RichTextFragment } from "../../../queries/fragments/RichTextFragment";
import { useMemo } from "react";
import {
  RichTextRenderOverrides,
  useRichTextRenderOptions,
} from "../../../hooks/useRichTextRenderOptions";
import {
  documentToReactComponents,
  Options,
} from "@contentful/rich-text-react-renderer";
import { Document as RichTextDocument } from "@contentful/rich-text-types";

export const RichText = ({
  content: maskedContentFragment,
  options: optionsProp,
  overrides,
}: {
  content?: FragmentOf<typeof RichTextFragment> | null;
  options?: Options;
  overrides?: RichTextRenderOverrides;
}) => {
  const content = readFragment(RichTextFragment, maskedContentFragment);

  const options = useMemo(
    () => ({
      options: optionsProp,
      overrides,
    }),
    [optionsProp, overrides]
  );

  const renderOptions = useRichTextRenderOptions(
    content?.richText?.links,
    options
  );

  const render = useMemo(
    () =>
      documentToReactComponents(
        content?.richText?.json as RichTextDocument,
        renderOptions
      ),
    [content, renderOptions]
  );

  return render;
};
